"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = Tooltip;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    width: fit-content;\n    font-family: ", ";\n    > .tooltip {\n        background-color: ", ";\n        position: absolute;\n        width: fit-content;\n        font-size: ", "rem;\n        color: ", ";\n        max-width: ", "px;\n        padding: ", "px;\n        opacity: ", ";\n        visibility: ", ";\n        transition: visibility ", "s linear ", "s, opacity ", "s linear;\n        transition-delay: ", "s;\n    }\n    > .bottom {\n        &:after {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-width: ", "px;\n        border-style: solid;\n        border-color: ", ";\n        bottom: 100%;\n        left: calc(50% - ", "px);\n        transform: rotate(90deg);\n        }\n    }\n    > .top {\n        &:after {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-width: ", "px;\n        border-style: solid;\n        border-color: ", ";\n        top: 100%;\n        left: calc(50% - ", "px);\n        transform: rotate(270deg);\n        }\n    }\n    > .right {\n        &:after {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-width: ", "px;\n        border-style: solid;\n        border-color: ", ";\n        top: calc(50% -  ", "px);\n        right: 100%;\n        transform: rotate(360deg);\n        }\n    }\n    > .left {\n        &:after {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-width:  ", "px;\n        border-style: solid;\n        border-color: ", ";\n        top: calc(50% -  ", "px);\n        left: 100%;\n        transform: rotate(180deg);\n        }\n    } \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.colorObj.color;
}, function (props) {
  return props.spacingObj.maxWidth;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.selected ? 1 : 0;
}, function (props) {
  return props.selected ? 'visible' : 'hidden';
}, function (props) {
  return props.fadeDuration / 1000;
}, function (props) {
  return props.fadeDuration / 1000;
}, function (props) {
  return props.fadeDuration / 1000;
}, function (props) {
  return props.duration / 1000;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.colorObj.borderColor;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.colorObj.borderColor;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.colorObj.borderColor;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.colorObj.borderColor;
}, function (props) {
  return props.spacingObj.padding * 2;
});
/**
 * The Tooltip component is used to  display informative text when users hover over or click an element.
 * 
 * To give an element a Tooltip, pass it through the Tooltip's children.
 * @example import { Tooltip } from '@desktop/react';
 */


function Tooltip(props) {
  var inherit = 'tooltip';
  var inputEl = (0, _react.useRef)(null);
  var tooltipRef = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var color = context.getColors()[inherit][props.type];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      dim = _useState4[0],
      setDim = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      tooltipName = _useState6[0],
      setTooltipName = _useState6[1];

  var _margin = spacing.margin;
  var interaction = buildElement();

  function buildElement() {
    var ele = {};

    switch (props.interaction) {
      case 'hover':
        ele = {
          onPointerEnter: onEvent,
          onPointerLeave: onEventLeave
        };
        break;

      case 'click':
        ele = {
          onClick: selected ? onEventLeave : onEvent
        };
        break;
    }

    return ele;
  }

  function onEvent() {
    if (!selected) {
      setSelected(!selected);
      setDim(getPos(inputEl, tooltipRef));
    }
  }

  function onEventLeave() {
    setSelected(false);
  }

  function getPos(ref, tooltipRef) {
    var rect = ref.getBoundingClientRect();
    var tooltip = tooltipRef.getBoundingClientRect();
    var body = document.body.getBoundingClientRect();
    var left,
        biggestSide,
        top = null;
    var arr = [{
      value: rect.top,
      name: 'top'
    }, {
      value: rect.left,
      name: 'left'
    }, {
      value: body.right - rect.right,
      name: 'right'
    }, {
      value: body.bottom - rect.bottom,
      name: 'bottom'
    }];

    if (!props.position) {
      biggestSide = arr.reduce(function (acc, value) {
        return acc.value > value.value ? acc : value;
      });

      if (tooltipName !== biggestSide.name) {
        setTooltipName(biggestSide.name);
      }
    }

    switch (props.position || biggestSide.name) {
      case 'left':
        left = "calc(0% - ".concat(tooltip.width + _margin, "px)");
        top = "calc(50% - ".concat(tooltip.height / 2, "px)");
        break;

      case 'right':
        left = "calc(100% + ".concat(_margin, "px)");
        top = "calc(50% - ".concat(tooltip.height / 2, "px)");
        break;

      case 'top':
        top = (tooltip.height + _margin) * -1;
        left = "calc(50% - ".concat(tooltip.width / 2, "px)");
        break;

      case 'bottom':
        top = "calc(100% + ".concat(_margin, "px)");
        left = "calc(50% - ".concat(tooltip.width / 2, "px)");
        break;
    }

    return {
      position: 'absolute',
      left: left,
      top: top
    };
  }

  return /*#__PURE__*/_react["default"].createElement(Container, {
    fadeDuration: props.fadeDuration,
    duration: props.duration,
    selected: selected,
    colorObj: color,
    spacingObj: spacing,
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: function ref(passed) {
      return tooltipRef = passed;
    },
    style: _objectSpread(_objectSpread({}, dim), props.style),
    className: "".concat(inherit, " ").concat(props.position || tooltipName)
  }, props.text), /*#__PURE__*/_react["default"].createElement("span", _extends({}, interaction, {
    ref: function ref(passed) {
      inputEl = passed;
    }
  }), props.children));
}

Tooltip.propTypes = {
  /**The component that the Tooltip is attatched to. */
  children: _propTypes["default"].node,

  /**The content that is used in the Tooltip when it shows. */
  text: _propTypes["default"].node,

  /**Time in ms taken for the visibilitiy of the tooltip to be shown or removed. */
  duration: _propTypes["default"].number,

  /**The fade transition period of the tooltip. */
  fadeDuration: _propTypes["default"].number,

  /**The overriding styling of the Tooltip component. */
  style: _propTypes["default"].object,

  /**Unique ID passed to the component required for multiple tooltip support. */
  id: _propTypes["default"].string,

  /**The direction that the tooltip will open when it's wrapped element is hovered over. */
  position: _propTypes["default"].string,

  /*The tooltip theme type. Can be either primary or secondary.* */
  type: _propTypes["default"].string,

  /**Signals the type of interaction that triggers the tooltip. This feature currently supports "hover" and "click". */
  interaction: _propTypes["default"].string
};
Tooltip.defaultProps = {
  text: null,
  duration: 2000,
  fadeDuration: 250,
  style: {},
  id: 'tooltip',
  position: null,
  type: 'primary',
  interaction: 'hover'
};